import { render, staticRenderFns } from "./ArtSearchingIcon.vue?vue&type=template&id=5444cece"
import script from "./ArtSearchingIcon.vue?vue&type=script&lang=js"
export * from "./ArtSearchingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports